module.exports = __webpack_public_path__ + "img/20191125164219567.7c8024fb.jpg";